<template>
    <div>
        <app-header messages="我" detail="租赁说明" pathName="/person/me" pathTo="/person/leasedesc"></app-header>
        <!--shopcart-->
        <div class="w">
            <div class="wb">
                <div class="news_show bg_w_s">
                    <h1>租赁说明</h1>
                    <div class="news_show_l">
<!--                        随租随还-->
<!--                        1.对于随租随还设备，超过6个月但不满约定租期提前退还的，不收取违约金，只需由乙方承担退货运费。-->
<!--                        2.随租随还设备，若6个月内退还且租期≤3个月，将收取3个月租金作为违约金，并由乙方承担退货运费；租期＞3个月，需补齐6个月租金作为违约金，并由乙方承担退货运费；设备正常归还、款项结清后合同终止。-->
<!--                        3.租期正常结束且不再续租时，设备需退还给租罗记，由租罗记承担退机运费。-->
<!--                        4.由于退机运输造成的设备损坏，由乙方和承运方承担损失。-->
<!--                        固定租期-->
<!--                        1.对于固定租期设备，乙方提前退还租赁设备，租罗记将收取原合约期内剩余租金的50%作为违约金，且租罗记无须退还其他押金或预付款，同时乙方需承担退机运费。-->
<!--                        2.租期正常结束且不再续租时，设备需退还给租罗记，由租罗记承担退机运费。-->
<!--                        3.由于退机运输造成的的设备损坏，由乙方和承运方承担损失。-->

                        <h3><big>租期说明</big></h3>
                        <h3>随租随还</h3>
                        <p>1. 对于随租随还设备，超过6个月但不满约定租期提前退还的，不收取违约金，只需由乙方承担退货运费。</p>
                        <p>2. 随租随还设备，若6个月内退还且租期≤3个月，将收取3个月租金作为违约金，并由乙方承担退货运费；租期＞3个月，需补齐6个月租金作为违约金，并由乙方承担退货运费；设备正常归还、款项结清后合同终止。</p>
                        <p>3. 租期正常结束且不再续租时，设备需退还给租罗记，由租罗记承担退机运费。</p>
                        <p>4. 由于退机运输造成的设备损坏，由乙方和承运方承担损失。</p>
                        <p></p>
                        <h3>固定租期</h3>
                        <p>1. 对于固定租期设备，乙方提前退还租赁设备，租罗记将收取原合约期内剩余租金的50%作为违约金，且租罗记无须退还其他押金或预付款，同时乙方需承担退机运费。</p>
                        <p>2. 租期正常结束且不再续租时，设备需退还给租罗记，由租罗记承担退机运费。</p>
                        <p>3. 由于退机运输造成的的设备损坏，由乙方和承运方承担损失。</p>

<!--                        <h3><big>租期说明</big></h3>-->
<!--                        <h3>随租随还</h3>-->
<!--                        <p>1. 6个月后可随时退还，承租方无需承担额外租金违约费用；但若租期未满12个月，客户需承担退机运费。</p>-->
<!--                        <p>2. 若6个月内退还(即实际租期不足6个月)，租罗记将收取额外3个月租金作为随租随还服务费同时客户需承担退机运费。</p>-->
<!--                        <p>3. 租期结束且不再续租时，设备需退还给租罗记。</p>-->
<!--                        <p>4. 由于退机运输造成的设备损坏，由客户和承运方承担损失。</p>-->
<!--                        <p></p>-->
<!--                        <h3>固定租期</h3>-->
<!--                        <p>1. 若提前退还设备，租罗记将收取原合约期内剩余租金的50%作为违约金，同时客户需承担退机运费。</p>-->
<!--                        <p>2. 租期结束且不再续租时，设备需退还给租罗记，由租罗记承担退机运费。</p>-->
<!--                        <p>3. 由于退机运输造成的的设备损坏，由客户和承运方承担损失。</p>-->
<!--                        <h3>组合租赁</h3>-->
<!--					    <p>1. 若提前退还设备，租罗记将收取原合约期内剩余租金的50%作为违约金，同时客户需承担退机运费。</p>-->
<!--                        <p>2. 租期结束且不再续租时，设备需退还给租罗记，由租罗记承担退机运费。</p>-->
<!--                        <p>3. 由于退机运输造成的的设备损坏，由客户和承运方承担损失。</p>-->
<!--                        <h3><big>租金扣款日说明</big></h3>-->

                        <h3><big>租金扣款日说明</big></h3>
                        <h3>扣款日</h3>
                        <p>1. 为保证用户的按月付款体验，每个用户有固定的扣款日，即每个月的固定的1个日期。</p>
                        <p>2. 扣款日的确定：扣款日是用户首次下单时，收到产品签收的日期。（扣款日针对除首次订单第一期以外的情形）</p>
                        <p>3. 例：某用户的首个订单在某月15日签收，则该用户的扣款日为今后每月的15日。</p>
                        <p>4. 若扣款日为29、30、31这三天，而当月没有该日期时，将在当月最后一天扣款。</p>
                        <p>5. 扣款时间为扣款日当天的23时，需要付款的用户请在此时间之前充值，保持账户余额充足。账户余额可在本站我的账户>我的钱包中查看。</p>
                        <h3>账单分期说明</h3>
                        <p>1. 订单的起租日期，为订单签收后的第二日。</p>
                        <p>2. 每个订单会根据用户的扣款日，按月拆分成具体的月租期。</p>
                        <p>3. 因为用户扣款日是固定的，而起租时间是灵活的，所以用户的租赁账单会根据扣款日拆分成n或n+1个账单，以便让之后每一期租期都从扣款之后的0点开始。</p>
                        <p>4. 例1：某用户的扣款日为每月15日，他有一个租期为3个月的订单，如果用户于5月15日签收订单商品，则订单从5月16日开始起租，8月15日结束。此用户的租赁账单分期详情为3期（n期）：</p>
                        <p>　　1)第1期：5月16日——6月15日；</p>
                        <p>　　2)第2期：6月16日——7月15日；</p>
                        <p>　　3)第3期：7月16日——8月15日。</p>
                        <p>5. 例2：如果例1中的用户于5月19日签收订单商品，则订单从5月20日开始起租，8月19日结束。此用户的租赁账单分期详情为4期（n+1期）：</p>
                        <p>　　1)第1期：5月20日——6月15日；</p>
                        <p>　　2)第2期：6月16日——7月15日；</p>
                        <p>　　3)第3期：7月16日——8月15日；</p>
                        <p>　　4)第4期：8月16日——8月19日。</p>
                        <h3>分期扣款计算说明</h3>
                        <p>1. 如果第1期租期天数不足一个月，如上一个例子所示，则第1期租金 = 月租金 * (本期天数 / 30天)，且结果四舍五入。</p>
                        <p>2. 最后1期租金 = 月租金 - 第1期租金。
                        <p>3. 例：某用户的扣款日为每月15日，他有一个租期为3个月，租金为100元/月，5月20日开始起租的订单。此用户的租赁账单分期扣款详情为4期。</p>
                        <p>　　1)第1期： 5月20日——6月15日，租金90元（= 100元 * 27天 / 30天）；</p>
                        <p>　　2)第2期： 6月16日——7月15日，租金100元；</p>
                        <p>　　3)第3期： 7月16日——8月15日，租金100元；</p>
                        <p>　　4)第4期： 8月16日——8月19日，租金10元（= 100元 - 第1期租金90元）；</p>
                        <p>订单总租金为300元，等于月租金100元 * 租期3个月。</p>
                        <h3>第1、2期付款金额说明</h3>
                        <p>1. 用户在下单时，需要实际支付完整1个月的租金。</p>
                        <p>2. 如果第1期租期天数不足1个月，而用户下单时已付了足1个月租金，那么多收的溢缴款将在第二期抵扣。</p>
                        <p>4. 例：如上一个例子所示租赁账单的分期情况，则用户实际付款情况如下：</p>
                        <p>　　1)第1期： 5月20日——6月15日，租金90元，实付100元，溢缴款10元；</p>
                        <p>　　2)第2期： 6月16日——7月15日，租金100元，实付90元，抵扣款10元；</p>
                        <p>　　3)第3期： 7月16日——8月15日，租金100元，实付100元；</p>
                        <p>　　4)第4期： 8月16日——8月19日，租金10元，实付10元；</p>
                        <p>订单总租金为300元，用户实付300元 = 100 + 90 + 100 + 10。 </p>
                    </div>
                    <Right></Right>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <!--shopcart end-->

        <app-footer></app-footer>
    </div>
</template>
<script>
    import AppHeader from '../../components/common/Header.vue'
    import AppFooter from '../../components/common/Footer.vue'

    import Right from '../../components/common/Right.vue'

    export default {
        name: "leasedesc",
        props:['messages','detail'],
        components: {
            AppHeader,
            AppFooter,

            Right
        }
    }
</script>



// WEBPACK FOOTER //
// src/center/person/leasedesc.vue